"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToString = exports.stringToNumber = void 0;
const enums_1 = require("../enums");
const stringToNumber = (usaVirgula, value) => {
    if (!value || value.trim() == '')
        return undefined;
    let num;
    if (usaVirgula == enums_1.ESistAvalUsaVirgula['Digitar com vírgula']) {
        num = parseFloat(value.indexOf(',') >= 0 && value.indexOf('.') >= 0
            ? value.replace('.', '').replace(',', '.')
            : value.indexOf(',') >= 0 && value.indexOf('.') < 0
                ? value.replace(',', '.')
                : value);
    }
    else {
        num = parseInt(value, 10);
    }
    return Number.isNaN(num) ? undefined : num;
};
exports.stringToNumber = stringToNumber;
const numberToString = (usaVirgula, value) => {
    if (!value && value !== 0)
        return undefined;
    if (usaVirgula == enums_1.ESistAvalUsaVirgula['Digitar com vírgula']) {
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
        }).format(value);
    }
    return value.toFixed();
};
exports.numberToString = numberToString;
